import React, { useState, useEffect } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";

const DEFAULT_IMG = 'https://w7.pngwing.com/pngs/527/625/png-transparent-scalable-graphics-computer-icons-upload-uploading-cdr-angle-text.png';

const SECCIONES = [
    { titulo: 'Documentación',          icon: 'bi-file-earmark-text', color: '#1d4ed8', bg: '#eff6ff',
      campos: ['tarjetapropiedad','tarjetamercancias','soat','revisiontecnica12','revisiontecnica6','resoluciondirectoral','resoluciongerencial','iqbf','certificadomatpel','certificadobonificacion','certificadooperatividad'] },
    { titulo: 'Identificación del vehículo', icon: 'bi-card-text',    color: '#7c3aed', bg: '#f5f3ff',
      campos: ['placarodaje','aniofabricacion','color','marca','modelo','carroceria','categoria','seriechasis','seriemarcamotor'] },
    { titulo: 'Equipamiento',            icon: 'bi-tools',            color: '#0891b2', bg: '#ecfeff',
      campos: ['radiocomunicacion','autorradio','llantarepuesto','camara','tablet','dispositivoseguridad','cajaherramientas','jaulaantivuelco','carriboy'] },
    { titulo: 'Estado y accesorios',     icon: 'bi-clipboard-check',  color: '#c81e22', bg: '#fdf2f2',
      campos: ['estadounidad','baranda','mamparon'] },
    { titulo: 'Tecnología y gestión',    icon: 'bi-cpu',              color: '#059669', bg: '#f0fdf4',
      campos: ['adas','gps','leasing'] },
    { titulo: 'Dimensiones y mecánica',  icon: 'bi-rulers',           color: '#b45309', bg: '#fffbeb',
      campos: ['ancho','longitud','alto','tiposuspencion','tipotornamesa'] },
];

export function Inventario() {
    const navigate = useNavigate();
    const [params] = useSearchParams();

    const [imagen1, setImagen1] = useState(null);
    const [imagen2, setImagen2] = useState(null);
    const [imagen3, setImagen3] = useState(null);
    const [imagen4, setImagen4] = useState(null);
    const [urlimagen1, setUrlImagen1] = useState(DEFAULT_IMG);
    const [urlimagen2, setUrlImagen2] = useState(DEFAULT_IMG);
    const [urlimagen3, setUrlImagen3] = useState(DEFAULT_IMG);
    const [urlimagen4, setUrlImagen4] = useState(DEFAULT_IMG);

    const onSelectImagen1 = e => { setUrlImagen1(URL.createObjectURL(e.target.files[0])); setImagen1(e.target.files[0]); };
    const onSelectImagen2 = e => { setUrlImagen2(URL.createObjectURL(e.target.files[0])); setImagen2(e.target.files[0]); };
    const onSelectImagen3 = e => { setUrlImagen3(URL.createObjectURL(e.target.files[0])); setImagen3(e.target.files[0]); };
    const onSelectImagen4 = e => { setUrlImagen4(URL.createObjectURL(e.target.files[0])); setImagen4(e.target.files[0]); };

    const codigo       = params.get('codigo')       ?? '';
    const idactivo     = params.get('idactivo')      ?? '';
    const tipo         = params.get('tipo')          ?? '';
    const usuario      = params.get('idpersonal')    ?? '';
    const tipovehiculo = params.get('tipovehiculo')  ?? 0;

    const [periodo,       setPeriodo]       = useState(null);
    const [nombreperiodo, setNombrePeriodo] = useState(null);
    const [observacion,   setObservacion]   = useState('');
    const [inventario,    setInventario]    = useState(null);
    const [cargando,      setCargando]      = useState(true);
    const [guardando,     setGuardando]     = useState(false);
    const [tipoplanilla,  setTipoPlanilla]  = useState('');
    const [planilla,      setPlanilla]      = useState(null);

    const camion       = ['1','5','6','7','8','9'];
    const remolcado    = ['23'];
    const semiremolque = ['19','20','21','22','24'];

    useEffect(() => {
        const camposplanilla = [
            { nombre:'tarjetapropiedad',        etiqueta:'Tarjeta de propiedad',          valor:false, campocomentario:'tarjetapropiedadcom',        comentario:'', visible:true },
            { nombre:'tarjetamercancias',        etiqueta:'Tarjeta de mercancías',         valor:false, campocomentario:'tarjetamercanciascom',        comentario:'', visible:true },
            { nombre:'soat',                     etiqueta:'SOAT',                          valor:false, campocomentario:'soatcom',                    comentario:'', visible:true },
            { nombre:'revisiontecnica12',        etiqueta:'Revisión técnica 12 meses',     valor:false, campocomentario:'revisiontecnica12com',        comentario:'', visible:true },
            { nombre:'revisiontecnica6',         etiqueta:'Revisión técnica 6 meses',      valor:false, campocomentario:'revisiontecnica6com',         comentario:'', visible:true },
            { nombre:'resoluciondirectoral',     etiqueta:'Resolución directoral',         valor:false, campocomentario:'resoluciondirectoralcom',     comentario:'', visible:true },
            { nombre:'resoluciongerencial',      etiqueta:'Resolución gerencial',          valor:false, campocomentario:'resoluciongerencialcom',      comentario:'', visible:true },
            { nombre:'iqbf',                     etiqueta:'IQBF',                          valor:false, campocomentario:'iqbfcom',                    comentario:'', visible:true },
            { nombre:'certificadomatpel',        etiqueta:'Certificado Matpel',            valor:false, campocomentario:'certificadomatpelcom',        comentario:'', visible:true },
            { nombre:'certificadobonificacion',  etiqueta:'Certificado bonificación',      valor:false, campocomentario:'certificadobonificacioncom',  comentario:'', visible:true },
            { nombre:'certificadooperatividad',  etiqueta:'Certificado de operatividad',   valor:false, campocomentario:'certificadooperatividadcom',  comentario:'', visible:true },
            { nombre:'placarodaje',              etiqueta:'Placa de rodaje',               valor:false, campocomentario:'placarodajecom',              comentario:'', visible:true },
            { nombre:'aniofabricacion',          etiqueta:'Año de fabricación',            valor:false, campocomentario:'aniofabricacioncom',          comentario:'', visible:true },
            { nombre:'color',                    etiqueta:'Color',                         valor:false, campocomentario:'colorcom',                   comentario:'', visible:true },
            { nombre:'marca',                    etiqueta:'Marca',                         valor:false, campocomentario:'marcacom',                   comentario:'', visible:true },
            { nombre:'modelo',                   etiqueta:'Modelo',                        valor:false, campocomentario:'modelocom',                  comentario:'', visible:true },
            { nombre:'carroceria',               etiqueta:'Carrocería',                    valor:false, campocomentario:'carroceriacom',               comentario:'', visible:true },
            { nombre:'categoria',                etiqueta:'Categoría',                     valor:false, campocomentario:'categoriacom',               comentario:'', visible:true },
            { nombre:'seriechasis',              etiqueta:'Serie de chasis',               valor:false, campocomentario:'seriechasiscom',              comentario:'', visible:true },
            { nombre:'seriemarcamotor',          etiqueta:'Serie y marca de motor',        valor:false, campocomentario:'seriemarcamotorcom',          comentario:'', visible:true },
            { nombre:'radiocomunicacion',        etiqueta:'Radio de comunicación',         valor:false, campocomentario:'radiocomunicacioncom',        comentario:'', visible:true },
            { nombre:'autorradio',               etiqueta:'Autorradio',                    valor:false, campocomentario:'autorradiocom',               comentario:'', visible:true },
            { nombre:'llantarepuesto',           etiqueta:'Llantas de repuesto',           valor:false, campocomentario:'llantarepuestocom',           comentario:'', visible:true },
            { nombre:'camara',                   etiqueta:'Cámara',                        valor:false, campocomentario:'camaracom',                  comentario:'', visible:true },
            { nombre:'tablet',                   etiqueta:'Tablet',                        valor:false, campocomentario:'tabletcom',                  comentario:'', visible:true },
            { nombre:'dispositivoseguridad',     etiqueta:'Dispositivos de seguridad',     valor:false, campocomentario:'dispositivoseguridadcom',     comentario:'', visible:true },
            { nombre:'estadounidad',             etiqueta:'Estado de la unidad',           valor:false, campocomentario:'estadounidadcom',             comentario:'', visible:true },
            { nombre:'cajaherramientas',         etiqueta:'Caja de herramientas',          valor:false, campocomentario:'cajaherramientascom',         comentario:'', visible:true },
            { nombre:'jaulaantivuelco',          etiqueta:'Jaula antivuelco',              valor:false, campocomentario:'jaulaantivuelcocom',          comentario:'', visible:true },
            { nombre:'carriboy',                 etiqueta:'Carriboy',                      valor:false, campocomentario:'carriboycom',                 comentario:'', visible:true },
            { nombre:'baranda',                  etiqueta:'Baranda',                       valor:false, campocomentario:'barandacom',                  comentario:'', visible:true },
            { nombre:'mamparon',                 etiqueta:'Mamparón',                      valor:false, campocomentario:'mamparoncom',                 comentario:'', visible:true },
            { nombre:'adas',                     etiqueta:'ADAS',                          valor:false, campocomentario:'adascom',                    comentario:'', visible:true },
            { nombre:'gps',                      etiqueta:'GPS',                           valor:false, campocomentario:'gpscom',                     comentario:'', visible:true },
            { nombre:'leasing',                  etiqueta:'Fecha término de leasing',      valor:false, campocomentario:'leasingcom',                  comentario:'', visible:true },
            { nombre:'ancho',                    etiqueta:'Ancho',                         valor:false, campocomentario:'anchocom',                   comentario:'', visible:true },
            { nombre:'longitud',                 etiqueta:'Longitud',                      valor:false, campocomentario:'longitudcom',                 comentario:'', visible:true },
            { nombre:'alto',                     etiqueta:'Alto',                          valor:false, campocomentario:'altocom',                    comentario:'', visible:true },
            { nombre:'tiposuspencion',           etiqueta:'Tipo de suspensión',            valor:false, campocomentario:'tiposuspencioncom',           comentario:'', visible:true },
            { nombre:'tipotornamesa',            etiqueta:'Tipo de tornamesa',             valor:false, campocomentario:'tipotornamesacom',            comentario:'', visible:true },
        ];

        const aplicarOcultar = (ocultar) => {
            ocultar.forEach(campo => {
                const idx = camposplanilla.findIndex(c => c.nombre === campo);
                if (idx !== -1) camposplanilla[idx].visible = false;
            });
        };

        let ocultar = [];
        if (camion.includes(String(tipovehiculo))) {
            setTipoPlanilla(1);
            ocultar = ['resoluciongerencial','certificadobonificacion','certificadooperatividad','cajaherramientas','jaulaantivuelco','carriboy','baranda','mamparon'];
        } else if (remolcado.includes(String(tipovehiculo))) {
            setTipoPlanilla(2);
            ocultar = ['llantarepuesto','cajaherramientas','jaulaantivuelco','carriboy','baranda','mamparon'];
        } else if (semiremolque.includes(String(tipovehiculo))) {
            setTipoPlanilla(3);
            ocultar = ['soat','seriemarcamotor','radiocomunicacion','autorradio','camara','tablet','dispositivoseguridad','cajaherramientas','jaulaantivuelco','carriboy','tipotornamesa'];
        } else {
            setTipoPlanilla(4);
            ocultar = ['revisiontecnica6','resoluciondirectoral','resoluciongerencial','iqbf','certificadomatpel','certificadobonificacion','certificadooperatividad','estadounidad','baranda','mamparon','tiposuspencion','tipotornamesa'];
        }

        fetch(process.env.REACT_APP_INVENTARIO_API_URL + "api/periodo/periodoActivo", { method:"GET", headers:{"Content-Type":"application/json"} })
            .then(r => r.json())
            .then(res => {
                if (res.rest != 1) { setPlanilla([]); return; }
                setNombrePeriodo(res.periodo.nombre);
                setPeriodo(res.periodo.idperiodo);
                fetch(process.env.REACT_APP_INVENTARIO_API_URL + "api/inventario/obtenerInventarioActualxidActivo/" + idactivo, { method:"GET", headers:{"Content-Type":"application/json"} })
                    .then(r => r.json())
                    .then(res => {
                        if (res.rest == 1) {
                            setInventario(res.inventario);
                            setObservacion(res.inventario.observacion);
                            const dir = process.env.REACT_APP_INVENTARIO_DIR_IMAGEN;
                            if (res.inventario.imagen1) setUrlImagen1(dir + res.inventario.imagen1);
                            if (res.inventario.imagen2) setUrlImagen2(dir + res.inventario.imagen2);
                            if (res.inventario.imagen3) setUrlImagen3(dir + res.inventario.imagen3);
                            if (res.inventario.imagen4) setUrlImagen4(dir + res.inventario.imagen4);

                            if (res.inventario.detalle) {
                                const d = res.inventario.detalle;
                                let ocultarDetalle = [];
                                if      (d.tipoplanilla == 1) { setTipoPlanilla(1); ocultarDetalle = ['resoluciongerencial','certificadobonificacion','certificadooperatividad','cajaherramientas','jaulaantivuelco','carriboy','baranda','mamparon']; }
                                else if (d.tipoplanilla == 2) { setTipoPlanilla(2); ocultarDetalle = ['llantarepuesto','cajaherramientas','jaulaantivuelco','carriboy','baranda','mamparon']; }
                                else if (d.tipoplanilla == 3) { setTipoPlanilla(3); ocultarDetalle = ['soat','seriemarcamotor','radiocomunicacion','autorradio','camara','tablet','dispositivoseguridad','cajaherramientas','jaulaantivuelco','carriboy','tipotornamesa']; }
                                else                          { setTipoPlanilla(4); ocultarDetalle = ['revisiontecnica6','resoluciondirectoral','resoluciongerencial','iqbf','certificadomatpel','certificadobonificacion','certificadooperatividad','estadounidad','baranda','mamparon','tiposuspencion','tipotornamesa']; }
                                camposplanilla.forEach(c => c.visible = true);
                                ocultarDetalle.forEach(campo => {
                                    const idx = camposplanilla.findIndex(c => c.nombre === campo);
                                    if (idx !== -1) camposplanilla[idx].visible = false;
                                });
                                camposplanilla.forEach((c, idx) => {
                                    camposplanilla[idx].valor      = d[c.nombre] ?? false;
                                    camposplanilla[idx].comentario = d[c.campocomentario] ?? '';
                                });
                            } else {
                                aplicarOcultar(ocultar);
                            }
                        } else {
                            aplicarOcultar(ocultar);
                        }
                        setPlanilla([...camposplanilla]);
                        setCargando(false);
                    });
            });
    }, []);

    const onTipoPlantillaChange = e => {
        const val = e.target.value;
        setTipoPlanilla(val);
        const actualizada = planilla.map(c => ({ ...c, visible: true }));
        let ocultar = [];
        if      (val == 1) ocultar = ['resoluciongerencial','certificadobonificacion','certificadooperatividad','cajaherramientas','jaulaantivuelco','carriboy','baranda','mamparon'];
        else if (val == 2) ocultar = ['llantarepuesto','cajaherramientas','jaulaantivuelco','carriboy','baranda','mamparon'];
        else if (val == 3) ocultar = ['soat','seriemarcamotor','radiocomunicacion','autorradio','camara','tablet','dispositivoseguridad','cajaherramientas','jaulaantivuelco','carriboy','tipotornamesa'];
        else               ocultar = ['revisiontecnica6','resoluciondirectoral','resoluciongerencial','iqbf','certificadomatpel','certificadobonificacion','certificadooperatividad','estadounidad','baranda','mamparon','tiposuspencion','tipotornamesa'];
        ocultar.forEach(campo => {
            const idx = actualizada.findIndex(c => c.nombre === campo);
            if (idx !== -1) actualizada[idx].visible = false;
        });
        setPlanilla(actualizada);
    };

    const onSeleccionPlanilla = (index) => {
        const updated = [...planilla];
        updated[index].valor = !updated[index].valor;
        setPlanilla(updated);
    };

    const onComentarioPlanilla = e => {
        const updated = [...planilla];
        updated[e.target.dataset.index].comentario = e.target.value;
        setPlanilla(updated);
    };

    const handleGuardar = e => {
        e.preventDefault();
        setGuardando(true);
        const data = { idactivo, codigo, periodo, observacion, usuario, tipo, tipoplanilla };
        if (tipo === 'flota') {
            planilla.forEach(({ nombre, valor, campocomentario, comentario }) => {
                data[nombre] = valor;
                data[campocomentario] = comentario;
            });
        }
        fetch(process.env.REACT_APP_INVENTARIO_API_URL + "api/inventario/store", {
            method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(data),
        })
            .then(r => r.json())
            .then(res => {
                if (res.rest === 1) {
                    if (imagen1 || imagen2 || imagen3 || imagen4) {
                        const file = new FormData();
                        file.append("file1", imagen1);
                        file.append("file2", imagen2);
                        file.append("file3", imagen3);
                        file.append("file4", imagen4);
                        file.append("idinventario", res.inventario.idinventario);
                        fetch(process.env.REACT_APP_INVENTARIO_API_URL + "api/inventario/imagen", { method:"POST", body: file })
                            .then(r => r.json())
                            .then(() => { setGuardando(false); navigate('/activo/resumen/?idactivo=' + idactivo + '&tipo=' + tipo + '&codigo=' + codigo); });
                    } else {
                        setGuardando(false);
                        navigate('/activo/resumen/?idactivo=' + idactivo + '&tipo=' + tipo + '&codigo=' + codigo);
                    }
                } else {
                    setGuardando(false);
                }
            })
            .catch(() => setGuardando(false));
    };

    const volverUrl = `/activo/resumen/?idactivo=${idactivo}&tipo=${tipo}&codigo=${codigo}`;
    const contarSeleccionados = () => planilla ? planilla.filter(c => c.visible && c.valor).length : 0;
    const contarVisibles      = () => planilla ? planilla.filter(c => c.visible).length : 0;

    return (
        <div className="inv-page">
            <style>{`
                .inv-page {
                    max-width: 1200px; margin: 0 auto;
                    padding: 1.5rem 1rem 4rem;
                    background: #f8fafc; min-height: 100vh;
                }
                @media (min-width: 900px) { .inv-page { padding: 2rem 2rem 4rem; } }

                /* Header */
                .inv-header { display:flex; align-items:flex-start; gap:1rem; margin-bottom:2rem; flex-wrap:wrap; }
                .inv-back {
                    display:inline-flex; align-items:center; gap:.35rem; flex-shrink:0;
                    color:#64748b; text-decoration:none; font-size:.82rem; font-weight:500;
                    background:#fff; border:1px solid #e2e8f0; border-radius:.5rem; padding:.45rem .9rem;
                    transition:color .15s, border-color .15s, box-shadow .15s;
                }
                .inv-back:hover { color:#c81e22; border-color:#fecaca; box-shadow:0 1px 4px rgba(200,30,34,.1); }
                .inv-title { margin:0; font-size:1.5rem; font-weight:800; color:#0f172a; letter-spacing:-.025em; line-height:1.2; }
                .inv-subtitle { font-size:.82rem; color:#334155; margin:.2rem 0 0; }
                .inv-flota-badge {
                    display:inline-flex; align-items:center; gap:.3rem; margin-top:.45rem;
                    background:#fdf2f2; color:#c81e22; border:1px solid #fecaca;
                    font-size:.68rem; font-weight:700; letter-spacing:.07em; text-transform:uppercase;
                    padding:.28rem .75rem; border-radius:.4rem;
                }
                .inv-counter { text-align:right; flex-shrink:0; }
                .inv-counter-val { font-size:1.4rem; font-weight:800; color:#c81e22; letter-spacing:-.03em; line-height:1; }
                .inv-counter-lbl { font-size:.68rem; color:#475569; margin-top:.1rem; }

                /* Grid */
                .inv-grid { display:grid; grid-template-columns:1fr; gap:1.25rem; align-items:start; }
                @media (min-width: 900px) { .inv-grid { grid-template-columns:1fr 380px; gap:1.5rem; } }

                /* Cards */
                .inv-card {
                    background:#fff; border-radius:1rem; overflow:hidden; margin-bottom:1rem;
                    border:1px solid #e2e8f0;
                    box-shadow:0 1px 3px rgba(0,0,0,.05), 0 4px 16px rgba(0,0,0,.04);
                }
                .inv-card:last-child { margin-bottom:0; }
                .inv-card-hdr {
                    display:flex; align-items:center; gap:.75rem;
                    padding:.95rem 1.25rem; border-bottom:1px solid #f1f5f9; background:#fafafa;
                }
                .inv-card-icon {
                    width:32px; height:32px; border-radius:.5rem; flex-shrink:0;
                    display:flex; align-items:center; justify-content:center;
                }
                .inv-card-title { font-weight:700; font-size:.88rem; color:#0f172a; }
                .inv-card-body { padding:.25rem 0; }

                /* Progress badge */
                .inv-progress {
                    margin-left:auto; font-size:.72rem; font-weight:700;
                    color:#475569; background:#f1f5f9; padding:.2rem .65rem; border-radius:100px;
                }

                /* Planilla selector */
                .inv-type-select {
                    width:100%; padding:.65rem .9rem;
                    border:1.5px solid #e2e8f0; border-radius:.75rem;
                    font-size:.88rem; color:#0f172a; background:#f8fafc;
                    outline:none; cursor:pointer; transition:border-color .2s, box-shadow .2s;
                }
                .inv-type-select:focus { border-color:#c81e22; box-shadow:0 0 0 3px rgba(200,30,34,.1); }

                /* Checklist items */
                .campo-item {
                    display:flex; align-items:center; gap:.75rem;
                    padding:.6rem 1.25rem; border-bottom:1px solid #f8fafc; transition:background .12s;
                }
                .campo-item:last-child { border-bottom:none; }
                .campo-item:hover { background:#fafafa; }
                .campo-check {
                    appearance:none; -webkit-appearance:none;
                    width:18px; height:18px; flex-shrink:0;
                    border:2px solid #e2e8f0; border-radius:.3rem; cursor:pointer;
                    position:relative; transition:border-color .15s, background .15s;
                }
                .campo-check:checked { background:#c81e22; border-color:#c81e22; }
                .campo-check:checked::after {
                    content:''; position:absolute; left:3px; top:0;
                    width:5px; height:9px;
                    border:2px solid #fff; border-top:none; border-left:none;
                    transform:rotate(45deg);
                }
                .campo-label {
                    flex:1; font-size:.83rem; color:#374151; cursor:pointer;
                    user-select:none; min-width:0;
                }
                .campo-input {
                    width:180px; flex-shrink:0; padding:.35rem .65rem;
                    border:1.5px solid #f1f5f9; border-radius:.5rem;
                    font-size:.78rem; color:#334155; background:#f8fafc; outline:none;
                    transition:border-color .2s;
                }
                .campo-input:focus { border-color:#c81e22; background:#fff; }
                @media (max-width: 600px) { .campo-input { width:100px; } }

                /* Images */
                .inv-images-flow { display:flow; grid-template-columns:1fr 1fr; gap:.75rem; padding:1.25rem; }
                .img-card {
                    aspect-ratio:4/3; border-radius:.75rem;
                    border:1.5px dashed #e2e8f0; overflow:hidden;
                    display:flex; align-items:center; justify-content:center;
                    background:#f8fafc; cursor:pointer;
                    transition:border-color .2s, background .2s; position:relative;
                }
                .img-card:hover { border-color:#c81e22; background:#fff8f8; }
                .img-card input[type="file"] { display:none; }
                .img-placeholder { display:flex; flex-direction:column; align-items:center; gap:.4rem; }
                .img-preview { position:absolute; inset:0; width:100%; height:100%; object-fit:cover; }
                .img-overlay {
                    position:absolute; inset:0;
                    background:rgba(200,30,34,.6);
                    display:flex; align-items:center; justify-content:center;
                    opacity:0; transition:opacity .2s; color:#fff; font-size:.8rem; font-weight:600;
                }
                .img-card:hover .img-overlay { opacity:1; }

                /* Observation */
                .inv-obs-input {
                    width:100%; padding:.75rem 1rem;
                    border:1.5px solid #e2e8f0; border-radius:.75rem;
                    font-size:.88rem; color:#0f172a; background:#f8fafc;
                    resize:vertical; min-height:90px; outline:none;
                    transition:border-color .2s, box-shadow .2s; font-family:inherit;
                }
                .inv-obs-input:focus { border-color:#c81e22; box-shadow:0 0 0 3px rgba(200,30,34,.1); background:#fff; }

                /* Save button */
                .inv-save-btn {
                    display:flex; align-items:center; justify-content:center; gap:.6rem;
                    width:100%; padding:1rem;
                    background:linear-gradient(135deg,#c81e22,#83090b);
                    color:#fff; font-size:.95rem; font-weight:700;
                    border:none; border-radius:.875rem; cursor:pointer;
                    box-shadow:0 4px 16px rgba(200,30,34,.3);
                    transition:transform .15s, box-shadow .2s;
                }
                .inv-save-btn:not(:disabled):hover { transform:translateY(-1px); box-shadow:0 6px 22px rgba(200,30,34,.4); }
                .inv-save-btn:disabled { opacity:.65; cursor:not-allowed; }

                /* Spinner */
                .inv-spin {
                    width:44px; height:44px; border-radius:50%;
                    border:3px solid #fde8e8; border-top-color:#c81e22;
                    animation:ispin .75s linear infinite; margin:0 auto 1rem;
                }
                @keyframes ispin { to { transform:rotate(360deg); } }
            `}</style>

            {/* ── Sin periodo activo / cargando ── */}
            {cargando && (
                <div style={{ textAlign:'center', padding:'4rem 1rem' }}>
                    {!planilla ? (
                        <>
                            <div className="inv-spin"></div>
                            <p style={{ color:'#334155', fontSize:'.9rem' }}>Cargando inventario...</p>
                        </>
                    ) : (
                        <>
                            <div style={{ width:64, height:64, background:'#fdf2f2', borderRadius:'50%', display:'flex', alignItems:'center', justifyContent:'center', margin:'0 auto 1.25rem', border:'1px solid #fecaca' }}>
                                <i className="bi bi-calendar-x" style={{ fontSize:'1.75rem', color:'#c81e22' }}></i>
                            </div>
                            <h5 style={{ fontWeight:700, color:'#0f172a', margin:'0 0 .5rem' }}>Sin periodo activo</h5>
                            <p style={{ color:'#334155', fontSize:'.88rem', maxWidth:360, margin:'0 auto 1.5rem' }}>
                                No hay un periodo de inventario activo. Contacte con el administrador del sistema.
                            </p>
                            <Link to={volverUrl} className="inv-back" style={{ justifyContent:'center', display:'inline-flex' }}>
                                <i className="bi bi-arrow-left"></i> Volver al resumen
                            </Link>
                        </>
                    )}
                </div>
            )}

            {/* ── Contenido principal ── */}
            {!cargando && planilla && (
                <>
                    {/* Header */}
                    <div className="inv-header">
                        <Link to={volverUrl} className="inv-back">
                            <i className="bi bi-arrow-left"></i> Volver
                        </Link>
                        <div style={{ flex:1, minWidth:0 }}>
                            <h1 className="inv-title">Inventario</h1>
                            <p className="inv-subtitle">
                                {codigo || `Activo #${idactivo}`}
                                {nombreperiodo && <span style={{ marginLeft:'.5rem', color:'#475569' }}>· {nombreperiodo}</span>}
                            </p>
                            {tipo === 'flota' && <span className="inv-flota-badge"><i className="bi bi-truck"></i>Flota</span>}
                        </div>
                        {tipo === 'flota' && (
                            <div className="inv-counter">
                                <div className="inv-counter-val">
                                    {contarSeleccionados()}<span style={{ fontSize:'.9rem', color:'#64748b', fontWeight:400 }}>/{contarVisibles()}</span>
                                </div>
                                <div className="inv-counter-lbl">ítems verificados</div>
                            </div>
                        )}
                    </div>

                    {/* Main grid */}
                    <div className="inv-grid">

                        {/* ── Columna izquierda: planilla ── */}
                        <div>
                            {tipo === 'flota' && (
                                <div className="inv-card" style={{ marginBottom:'1rem' }}>
                                    <div className="inv-card-hdr">
                                        <div className="inv-card-icon" style={{ background:'#fdf2f2' }}>
                                            <i className="bi bi-list-check" style={{ color:'#c81e22', fontSize:'.9rem' }}></i>
                                        </div>
                                        <span className="inv-card-title">Tipo de planilla</span>
                                    </div>
                                    <div style={{ padding:'1rem 1.25rem' }}>
                                        <select className="inv-type-select" value={tipoplanilla} onChange={onTipoPlantillaChange}>
                                            <option value={1}>Camión</option>
                                            <option value={2}>Remolcador</option>
                                            <option value={3}>Semiremolque</option>
                                            <option value={4}>Equipo liviano</option>
                                        </select>
                                    </div>
                                </div>
                            )}

                            {SECCIONES.map(seccion => {
                                const items = planilla
                                    .map((c, idx) => ({ ...c, idx }))
                                    .filter(c => seccion.campos.includes(c.nombre) && c.visible);
                                if (items.length === 0) return null;
                                const seleccionados = items.filter(c => c.valor).length;
                                return (
                                    <div key={seccion.titulo} className="inv-card">
                                        <div className="inv-card-hdr">
                                            <div className="inv-card-icon" style={{ background: seccion.bg }}>
                                                <i className={`bi ${seccion.icon}`} style={{ color: seccion.color, fontSize:'.9rem' }}></i>
                                            </div>
                                            <span className="inv-card-title">{seccion.titulo}</span>
                                            <span className="inv-progress">{seleccionados}/{items.length}</span>
                                        </div>
                                        <div className="inv-card-body">
                                            {items.map(item => (
                                                <div key={item.nombre} className="campo-item">
                                                    <input
                                                        type="checkbox" className="campo-check"
                                                        id={`chk-${item.nombre}`}
                                                        checked={item.valor}
                                                        onChange={() => onSeleccionPlanilla(item.idx)}
                                                    />
                                                    <label className="campo-label" htmlFor={`chk-${item.nombre}`}>
                                                        {item.etiqueta}
                                                    </label>
                                                    <input
                                                        type="text" className="campo-input"
                                                        placeholder="Comentario..."
                                                        value={item.comentario}
                                                        data-index={item.idx}
                                                        onChange={onComentarioPlanilla}
                                                    />
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>

                        {/* ── Columna derecha ── */}
                        <div style={{ display:'flex', flexDirection:'column', gap:'1rem' }}>

                            {/* Fotografías */}
                            <div className="inv-card">
                                <div className="inv-card-hdr">
                                    <div className="inv-card-icon" style={{ background:'#ecfeff' }}>
                                        <i className="bi bi-camera" style={{ color:'#0891b2', fontSize:'.9rem' }}></i>
                                    </div>
                                    <span className="inv-card-title">Fotografías</span>
                                    <span className="inv-progress">
                                        {[urlimagen1,urlimagen2,urlimagen3,urlimagen4].filter(u => u !== DEFAULT_IMG).length}/4
                                    </span>
                                </div>
                                <div className="inv-images-flow">
                                    {[
                                        { url: urlimagen1, onSelect: onSelectImagen1, label: 'Foto 1' },
                                        { url: urlimagen2, onSelect: onSelectImagen2, label: 'Foto 2' },
                                        { url: urlimagen3, onSelect: onSelectImagen3, label: 'Foto 3' },
                                        { url: urlimagen4, onSelect: onSelectImagen4, label: 'Foto 4' },
                                    ].map((img, i) => (
                                        <label key={i} className="img-card">
                                            <input type="file" accept="image/*" onChange={img.onSelect} />
                                            {img.url !== DEFAULT_IMG ? (
                                                <>
                                                    <img src={img.url} className="img-preview" alt={img.label} />
                                                    <div className="img-overlay">
                                                        <i className="bi bi-camera me-1"></i> Cambiar
                                                    </div>
                                                </>
                                            ) : (
                                                <div className="img-placeholder">
                                                    <i className="bi bi-camera-fill" style={{ fontSize:'1.4rem', color:'#cbd5e1' }}></i>
                                                    <span style={{ fontSize:'.72rem', color:'#64748b' }}>{img.label}</span>
                                                </div>
                                            )}
                                        </label>
                                    ))}
                                </div>
                            </div>

                            {/* Observación */}
                            <div className="inv-card">
                                <div className="inv-card-hdr">
                                    <div className="inv-card-icon" style={{ background:'#f5f3ff' }}>
                                        <i className="bi bi-chat-square-text" style={{ color:'#7c3aed', fontSize:'.9rem' }}></i>
                                    </div>
                                    <span className="inv-card-title">Observación</span>
                                </div>
                                <div style={{ padding:'1rem 1.25rem' }}>
                                    <textarea
                                        className="inv-obs-input"
                                        placeholder="Anote observaciones relevantes del activo..."
                                        value={observacion}
                                        onChange={e => setObservacion(e.target.value)}
                                        rows={4}
                                    />
                                </div>
                            </div>

                            {/* Guardar */}
                            <button className="inv-save-btn" onClick={handleGuardar} disabled={guardando}>
                                {guardando ? (
                                    <><span className="spinner-border spinner-border-sm" role="status"></span> Guardando...</>
                                ) : (
                                    <><i className="bi bi-check2-circle"></i> Guardar inventario</>
                                )}
                            </button>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
}
